import { CircularProgress } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import React from 'react'
import styles from './styles'

const Loader = ({ classes }) => {
  return (
    <div className={classes.wrapper}>
      <CircularProgress size={25} />
    </div>
  )
}

export default withStyles(styles)(Loader)
